// Primary brand color
export const PRIMARY = "#00CD1F";

// rgba helper — rgb(0, 205, 31)
export const primaryAlpha = (opacity) => `rgba(0, 205, 31, ${opacity})`;
